
import {
  benefits,
  popularServices,
  questions,
  uses,
} from "~/data/privateCloud";
import Modal from "~/components/rebranding/modal/Modal.vue";
import Benefits from "~/components/privateCloud/Benefits.vue";
import Uses from "~/components/privateCloud/Uses.vue";

export default {
  components: {
    Benefits,
    Uses,
    Modal,
  },
  data() {
    return {
      activeSection: "",
      FormTitle: "",
      benefits,
      popularServices,
      questions,
      uses,
    };
  },
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title:
        "خرید سرور اختصاصی با پشتیبانی ۲۴ ساعته | راهکارهای سازمانی آبالون",
      meta: [
        {
          name: "description",
          content:
            "خرید سرور اختصاصی آبالون | پلن‌های متنوع سازمانی | ایمن و سریع با جدیدترین سخت‌افزارهای روز دنیا | پشتیبانی ۲۴/۷ | راهکارهای سازمانی آبالون",
        },
        {
          name: "keywords",
          content:
            "راهکارهای سازمانی آبالون ,خرید سرور اختصاصی ,خرید سرور اختصاصی آبالون ,سرور اختصاصی",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/privateCloud",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content:
            "خرید سرور اختصاصی با پشتیبانی ۲۴ساعته | راهکارهای سازمانی آبالون",
        },
        {
          property: "og:description",
          content:
            "خرید سرور اختصاصی آبالون | پلن‌های متنوع سازمانی | ایمن و سریع با جدیدترین سخت‌افزارهای روز دنیا | پشتیبانی ۲۴/۷ | راهکارهای سازمانی آبالون",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/privateCloud",
        },
        {
          name: "twitter:title",
          title:
            "خرید سرور اختصاصی با پشتیبانی ۲۴ساعته | راهکارهای سازمانی آبالون",
        },
        {
          name: "twitter:description",
          content:
            "خرید سرور اختصاصی آبالون | پلن‌های متنوع سازمانی | ایمن و سریع با جدیدترین سخت‌افزارهای روز دنیا | پشتیبانی ۲۴/۷ | راهکارهای سازمانی آبالون",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],

      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/privateCloud",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "ابر خصوصی آبالون چه تفاوتی با سرویس‌های عمومی ابری دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "ابر خصوصی آبالون فقط برای سازمان شما پیاده‌سازی می‌شود و منابع، داده‌ها و کنترل زیرساخت، کاملاً در اختیار خودتان است.",
                },
              },
              {
                "@type": "Question",
                name: "آیا امکان استفاده از سرورهای فعلی سازمان برای راه‌اندازی ابر خصوصی وجود دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله، در صورتی که سخت‌افزار فعلی شما از الزامات فنی پلتفرم پشتیبانی کند، نیازی به خرید سرور جدید نخواهید داشت.",
                },
              },
              {
                "@type": "Question",
                name: "فرآیند مهاجرت از زیرساخت سنتی به ابر چقدر زمان می‌برد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بسته به پیچیدگی زیرساخت، نوع سرویس‌ها و نیازهای سفارشی، مدت زمان پروژه می‌تواند از چند روز تا چند هفته متغیر باشد.",
                },
              },
              {
                "@type": "Question",
                name: "امنیت داده‌ها در ابر خصوصی چگونه تضمین می‌شود؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "تمام داده‌ها در داخل سازمان ذخیره می‌شوند و با لایه‌های امنیتی سفارشی‌شده، کنترل کامل بر دسترسی‌ها فراهم می‌شود.",
                },
              },
              {
                "@type": "Question",
                name: "آیا می‌توان از نرم‌افزارهای فعلی مانند ERP یا CRM روی ابر خصوصی استفاده کرد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله، خدمات ابر خصوصی آبالون امکان انتقال و اجرای نرم‌افزارهای حیاتی سازمانی مانند ERP، CRM و حسابداری را فراهم می‌کند.",
                },
              },
              {
                "@type": "Question",
                name: "آیا ابر خصوصی قابلیت مقیاس‌پذیری دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله، زیرساخت مبتنی بر OpenStack به شما این امکان را می‌دهد تا منابع پردازشی، ذخیره‌سازی و شبکه را به‌راحتی گسترش دهید.",
                },
              },
              {
                "@type": "Question",
                name: "چه میزان دسترسی به پلتفرم ابری برای تیم IT سازمان فراهم می‌شود؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "تیم IT سازمان می‌تواند به‌صورت کامل و با دسترسی سطح بالا، مدیریت منابع، ماشین‌های مجازی و سرویس‌ها را بر عهده بگیرد.",
                },
              },
              {
                "@type": "Question",
                name: "آیا امکان مانیتورینگ و مشاهده عملکرد سیستم در لحظه وجود دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله، داشبوردهای مدیریتی پیشرفته برای نظارت بر منابع، مصرف، رخدادها و سلامت کلی زیرساخت در اختیار شما قرار می‌گیرد.",
                },
              },
              {
                "@type": "Question",
                name: "پشتیبانی آبالون در چه سطوحی ارائه می‌شود؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "پشتیبانی فنی به‌صورت ۲۴/۷ از طریق تیکت و تماس تلفنی برای حل مشکلات و مشاوره‌های تخصصی ارائه می‌شود.",
                },
              },
              {
                "@type": "Question",
                name: "هزینه راه‌اندازی ابر خصوصی چگونه محاسبه می‌شود؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "هزینه‌ها بر اساس تحلیل نیازهای سازمان، تعداد سرورها، سطح منابع و میزان پشتیبانی فنی مورد نیاز برآورد می‌شوند.",
                },
              },
            ],
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org/",
            "@type": "Review",
            itemReviewed: {
              "@type": "CreativeWorkSeries",
              name: "سرور اختصاصی با پشتیبانی ۲۴ ساعته آبالون",
            },
            author: {
              "@type": "Person",
              name: "Hamid Karimi",
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: "4.9",
              bestRating: "5",
            },
            publisher: {
              "@type": "Organization",
              name: "Abalon Cloud Solutions",
            },
          },
        },
      ],
    };
  },
};
